/**
 * SECTION 2A JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Section 2A, data
         * UI interaction functions etc
         */
        console.log( 'Section 2A - init' );

        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });

    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        /*var jsonDataString = JSON.stringify( this.aon_section_4b_data );
        console.log( 'jsonDataString: ' + jsonDataString );*/
        
        console.log( '2A - AJAX - START' );
        var meta = { 'section_2a_data_one' : '[{"status": "completed"}]' };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '2A - AJAX - END' );
        
    }
    

}